(() => {
  const initializeFaqPages = (scope = document) => {
    scope.querySelectorAll('[data-faq-page]').forEach((faqPage) => {
      if (faqPage.dataset.faqInteractive === 'true') return;
      faqPage.dataset.faqInteractive = 'true';

      const items = [...faqPage.querySelectorAll('.faq-page__item')];

      const setExpanded = (detail, shouldOpen) => {
        const summary = detail.querySelector(':scope > summary');
        const answer = detail.querySelector('[data-faq-answer]');
        if (!summary || !answer) return;

        answer.getAnimations().forEach((animation) => animation.cancel());
        const startHeight = answer.getBoundingClientRect().height;

        if (shouldOpen) detail.open = true;

        const endHeight = shouldOpen ? answer.scrollHeight : 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        summary.setAttribute('aria-expanded', String(shouldOpen));

        const animation = answer.animate(
          [
            { height: `${startHeight}px` },
            { height: `${endHeight}px` },
          ],
          {
            duration: reduceMotion ? 0 : 250,
            easing: 'ease',
          }
        );

        animation.addEventListener('finish', () => {
          detail.open = shouldOpen;
          answer.style.height = shouldOpen ? 'auto' : '0px';
        }, { once: true });
      };

      items.forEach((detail) => {
        const summary = detail.querySelector(':scope > summary');
        const answer = detail.querySelector('[data-faq-answer]');
        if (!summary || !answer) return;

        answer.style.height = detail.open ? 'auto' : '0px';
        summary.setAttribute('aria-expanded', String(detail.open));
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          const shouldOpen = summary.getAttribute('aria-expanded') !== 'true';

          if (shouldOpen) {
            items.forEach((item) => {
              if (item !== detail) {
                const itemSummary = item.querySelector(':scope > summary');
                if (itemSummary?.getAttribute('aria-expanded') === 'true') {
                  setExpanded(item, false);
                }
              }
            });
          }

          setExpanded(detail, shouldOpen);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFaqPages(), { once: true });
  } else {
    initializeFaqPages();
  }

  document.addEventListener('shopify:section:load', (event) => initializeFaqPages(event.target));
})();
